import { Schema } from '../types'
import { commonColumns } from './common_schema'

export const criticalIssueSchema: Schema = {
  title: 'Critical Issue Checklist',
  columns: commonColumns
}
